import { useEffect, useMemo, useState } from 'react';
import { apiClient } from './api';
import useAuth from '../context/AuthProvider';

interface ExtractionState {
    name: string;
    aliases: string[];
};

/** Fetches the list of live extraction states from the API and returns helper functions built from
 *  that list. Add a new state on the backend only — nothing here needs to change. */
export function useExtractionStates() {
    const { user } = useAuth();
    const [states, setStates] = useState<ExtractionState[]>([]);

    useEffect(() => {
        if (!user?.token) return;
        apiClient('/AutomaticFiling/getExtractionStates', {
            headers: { Authorization: `Bearer ${user.token}` },
        }).then((res: any) => {
            if (Array.isArray(res?.data)) setStates(res.data);
        });
    }, [user?.token]);

    const segmentMap = useMemo(() => {
        const map: Record<string, string> = {};
        for (const s of states) {
            map[s.name.toLowerCase()] = s.name;
            for (const alias of s.aliases) {
                map[alias.toLowerCase()] = s.name;
            }
        }
        return map;
    }, [states]);

    const stateSegment = (raw?: string | null): string | null =>
        raw ? segmentMap[raw.trim().toLowerCase()] ?? null : null;

    const isFilingReviewSupportedState = (raw?: string | null): boolean => stateSegment(raw) !== null;

    return { stateSegment, isFilingReviewSupportedState, states };
};
